module.exports = __webpack_public_path__ + "static/media/24a.6167e316.jpg";